<div class="row full-width-bg" id="component-top">
  <div class="col">
    <app-breadcrumbs [breadcrumbs]="breadcrumbs()"></app-breadcrumbs>
  </div>
</div>

<div class="row full-width-bg">
  <div class="col">
    <div class="flex flex-row gap-6 items-start">
      <div class="grow min-h-36 flex flex-col justify-between max-w-full">
        @if (searchDescription() && searchResultContent()) {
          <app-search-short-description-v2
            (scrollDownClicked)="scrollToSearchDescription($event)"
            [count]="total()"
            [pluralName]="
                            searchResultContent()?.caregiverUnitType?.pluralName ||
                            searchResultContent()?.caregiverUnitType?.name
                          "
            [searchDescription]="searchDescription()"
            [searchResultContent]="searchResultContent()"
          ></app-search-short-description-v2>
        }

        <div
          (inViewportAction)="handleTabsInViewport($event)"
          [inViewportOptions]="{threshold: 0}"
          class="tabs-viewport-marker full-width-bg"
          inViewport
        >
          <div [ngStyle]="placeholderStyle()"></div>
          <div [ngClass]="topSectionCssClass()"
               class="top-section bg-white border-b-2 border-b-grey-9 flex justify-center items-start"
               id="top-section-container">
            <div class="max-w-[1184px] w-full">

              <div class="tabs-container min-h-12 w-full min-w-full max-w-full">
                <nav (selectFocusedIndex)="onTabChange($event)" [tabPanel]="tabPanel" mat-tab-nav-bar>
                  @for (link of tabs(); track link.name; let i = $index) {
                    <a mat-tab-link
                       (click)="cpruTabsService.handleTabsIndexChange(link.name)"
                       [active]="highlightedSection() === link.name">
                      <app-ui-icon color="var(--grey-0)" [name]="link.icon" size="md" *ngIf="link.icon"
                                   class="hidden sm:inline-flex mr-2"></app-ui-icon>
                      {{ link.label }}
                      <div class="ml-1 opacity-50 inline-block text-xs sm:text-base" *ngIf="link.count">
                        ({{ link.count }})
                      </div>
                    </a>
                  }
                </nav>
                <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hidden md:block w-80 min-w-80">
        @if (searchState()) {
          <app-google-map-quick-loader-v2
            [addBackgroundMap]="true"
            [color]="'flat'"
            [expanded]="'inline'"
            [size]="'md'"
          ></app-google-map-quick-loader-v2>
        }
      </div>
    </div>
  </div>
</div>

<div class="row mt-6">
  <div class="col">
    @if (results()) {
      <div class="search-results-container">
        @if (total() === 0 && highlightedSection() === RoutesAddonsEnums.SERP_CAREPROVIDERS) {
          <section class="p-8 bg-white rounded-lg text-lg">
            <p>Tyvärr finns inga mottagningar på den sökning du gjorde.</p>
          </section>
        }

        @if (total() === 0 && highlightedSection() === RoutesAddonsEnums.SERP_SERVICES) {
          <section class="p-8 bg-white rounded-lg text-lg">
            <p>Tyvärr finns inga behandlingar på den sökning du gjorde.</p>
          </section>
        }

        @if (results().length > 0) {
          <section>
            <div class="search-results-list">

              @if (isRedirected()) {
                <div class="redirect-alert-container">
                  <h4>Din sökning gav tyvärr inga träffar.</h4>
                  <p>
                    Vi har inaktiverat några av sökkriterierna för att presentera
                    de mest relevanta resultaten.
                  </p>
                </div>
              }

              <app-search-results-list-v5
                [results]="results()"
                [searchState]="searchState()"
              ></app-search-results-list-v5>
              <div class="flex w-full pt-2 pr-2 justify-end text-sm">
                <a [routerLink]="relatedLink()">relaterade sökningar</a>
              </div>
            </div>

            <div class="search-results-bottom-tools">
              <app-pagination-v2
                [baseUrlTab]="baseUrl"
                [currentPage]="page()"
                [getQueryParams]="getSearchResultsQueryParams"
                [getRouterLink]="getSearchResultRoute"
                [maxLength]="4"
                [overwriteRouteParams]="routerQueryParams()"
                [pageParameterName]="'page'"
                [pageSize]="pageSize()"
                [total]="total()"
                class="bottom-tools-pagination"
              >
              </app-pagination-v2>
            </div>
          </section>
        }


        @if (searchDescription() && searchResultContent()) {
          <app-search-long-description-v2
            [count]="total()"
            [data]="searchCategoryInfoAggregations()"
            [name]="searchResultContent()?.caregiverUnitType?.name"
            [place]="searchResultContent()?.place?.name"
            [pluralName]="
                                  searchResultContent()?.caregiverUnitType?.pluralName ||
                                  searchResultContent()?.caregiverUnitType?.name
                                "
            [searchDescription]="searchDescription()"
            [searchResultContent]="searchResultContent()"
            class="long-description"
          ></app-search-long-description-v2>
        }
      </div>
    }

  </div>

  <div class="col-s">
    @if (areCpruTypesLoaded() === true) {
      <app-sidebar
        [isAdVisible]="true"
        [pageType]="pageType"
      >
        <app-search-faq faq></app-search-faq>
      </app-sidebar>
    }
  </div>
</div>
